/*eslint-disable */
const $ = window.jQuery = require('jquery');
export default {
  name: 'mobile-menu-bar',
  components: {},
  props: ['notificationBadgeINFO'],
  data () {
    return {
      mobileMenuBaar:false,
      subMblMenuState:'home',
      isMobile: false,
      notificationBadgeInfo:null
    }
  },
  computed: {
  },
  mounted () {
    this.notificationBadgeInfo = this.notificationBadgeINFO;
  },
  methods: {
    menuBarOpenMehtod(){
      this.mobileMenuBaar = true;
      document.body.classList.add('body_right_scroll_remove');
    },
    menuBarClosedMehtod(){
      this.mobileMenuBaar = false;
      this.subMblMenuState = 'home';
      document.body.classList.remove('body_right_scroll_remove');
    },
    subMblMenuMethod(data){
      this.subMblMenuState = data;
    },
    subMblMenuClosedMethod(){
      this.subMblMenuState = '';
    },
    logoutFromAllTabMethod() {
      if ('BroadcastChannel' in self) {
        authChannel.postMessage({
          cmd: 'logout'
        })
      }
    },
    logout(){
      this.$store.dispatch('logoutAction')
      .then(() => {
        this.logoutFromAllTabMethod();
      })
    },
  } 
}